"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availabilityV3Api = void 0;
const stripTimezone = (date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
};
exports.availabilityV3Api = (http, prefix = '/availability-v3') => ({
    getEventsByPropertyId(propertyId) {
        return http.get(`${prefix}/events/property/${propertyId}`);
    },
    blockByDateRange(event) {
        const stringStart = stripTimezone(event.startOn);
        const stringEnd = stripTimezone(event.endOn);
        return http.post(`${prefix}/events/property/${event.property_id}/start/${stringStart}/end/${stringEnd}/managed_by/travelnest.com`, {});
    },
    resolveEvents(property, events, mode) {
        const payload = events.map((e) => ({ start_on: stripTimezone(e.startOn), end_on: stripTimezone(e.endOn), block_reason: e === null || e === void 0 ? void 0 : e.block_reason }));
        if (mode === 'create') {
            return http.post(`${prefix}/events/property/${property}/resolve`, payload);
        }
        else {
            return http.delete(`${prefix}/events/property/${property}/resolve`, { data: payload });
        }
    }
});
//# sourceMappingURL=index.js.map